<template lang="pug">
  button.live-chat(
    :class="full && 'show-text'"
    title="Live Chat"
    tabindex="0"
    @click="openLiveChat()"
  )
    span.text {{ __('Live Chat') }}
</template>
<script setup lang="ts">
import { useLiveChat } from '@/js/composables/useLiveChat'

withDefaults(defineProps<{
  full?: boolean,
}>(), {
  full: false,
})

const { openLiveChat } = useLiveChat()
</script>

<style lang="scss" scoped>
.live-chat{
  color: $color-gray-x-dark;
  background: transparent;
  cursor: pointer;
  text-decoration: none;
  padding: 0 $space-xxs;
  border: 0;

  &:first-child {
    padding-left: 0;
  }

  &:hover {
    text-decoration: underline;
    color: $color-black-light;
  }

  &::after {
    display: inline-block;
    width: 22px;
    height: 16px;
    margin-left: 4px;
    content: "";
    vertical-align: text-top;
    background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAxOS4xLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9Ii00NTMgMjU5LjcgNTEuNiA0Mi4zIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IC00NTMgMjU5LjcgNTEuNiA0Mi4zOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPg0KCS5zdDB7ZmlsbDojQ0NDQ0NDO30NCgkuc3Qxe2ZpbGw6Izk5OTk5OTt9DQo8L3N0eWxlPg0KPGNpcmNsZSBjbGFzcz0ic3QwIiBjeD0iLTQxMC40IiBjeT0iMjY4LjciIHI9IjkiLz4NCjxnPg0KCTxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik0tNDM1LjgsMjkyLjhsLTAuNC0wLjFjLTkuNi0xLjktMTYuMy03LjUtMTYuMy0xMy44YzAtOCwxMC40LTE0LjUsMjMuMS0xNC41YzAuOCwwLDEuNywwLDIuNSwwLjENCgkJYy0wLjQsMS40LTAuNSwyLjgtMC41LDQuMmMwLDkuNCw3LjYsMTcsMTcsMTdjMC41LDAsMSwwLDEuNS0wLjFjLTMuMiwzLjgtOSw2LjYtMTUuOCw3LjVoLTAuMWwtMTIuMyw3LjlMLTQzNS44LDI5Mi44eiIvPg0KCTxwYXRoIGNsYXNzPSJzdDEiIGQ9Ik0tNDI5LjQsMjY0LjljMC42LDAsMS4yLDAsMS45LDBjLTAuMywxLjItMC40LDIuNS0wLjQsMy43YzAsOS42LDcuOCwxNy41LDE3LjUsMTcuNWMwLjEsMCwwLjIsMCwwLjMsMA0KCQljLTMuMywzLjMtOC42LDUuNi0xNC43LDYuNGgtMC4ybC0wLjIsMC4ybC0xMS4zLDcuMmwxLjEtNi42bDAuMi0xbC0xLTAuMmMtOS4zLTEuNy0xNS44LTcuMi0xNS44LTEzLjINCgkJQy00NTIsMjcxLjItNDQxLjksMjY0LjktNDI5LjQsMjY0LjkgTS00MjkuNCwyNjMuOWMtMTMsMC0yMy42LDYuNy0yMy42LDE1YzAsNi43LDcsMTIuNCwxNi43LDE0LjNsLTEuNSw4LjhsMTMuMi04LjUNCgkJYzcuNi0xLDEzLjktNC4zLDE2LjktOC42Yy0wLjksMC4xLTEuOCwwLjItMi43LDAuMmMtOS4xLDAtMTYuNS03LjQtMTYuNS0xNi41YzAtMS42LDAuMi0zLjIsMC43LTQuNg0KCQlDLTQyNy4zLDI2NC00MjguMywyNjMuOS00MjkuNCwyNjMuOUwtNDI5LjQsMjYzLjl6Ii8+DQo8L2c+DQo8L3N2Zz4NCg==);
    background-repeat: no-repeat;
    background-size: contain;
  }
}

.live-chat:not(.show-text){
  .text {
    @include not-desktop() {
      display:none;
    }
  }
}

</style>

<style lang="scss">
#app.chat-online .live-chat::after {
  background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAxOS4xLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCA1MS42IDQyLjMiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxLjYgNDIuMzsiIHhtbDpzcGFjZT0icHJlc2VydmUiPg0KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4NCgkuc3Qwe2ZpbGw6IzFBQjE0Qjt9DQoJLnN0MXtmaWxsOiNDQ0NDQ0M7fQ0KCS5zdDJ7ZmlsbDojOTk5OTk5O30NCjwvc3R5bGU+DQo8Y2lyY2xlIGNsYXNzPSJzdDAiIGN4PSI0Mi42IiBjeT0iOSIgcj0iOSIvPg0KPGc+DQoJPHBhdGggY2xhc3M9InN0MSIgZD0iTTE3LjIsMzMuMUwxNi44LDMzQzcuMiwzMS4xLDAuNSwyNS41LDAuNSwxOS4yYzAtOCwxMC40LTE0LjUsMjMuMS0xNC41YzAuOCwwLDEuNywwLDIuNSwwLjENCgkJYy0wLjQsMS40LTAuNSwyLjgtMC41LDQuMmMwLDkuNCw3LjYsMTcsMTcsMTdjMC41LDAsMSwwLDEuNS0wLjFjLTMuMiwzLjgtOSw2LjYtMTUuOCw3LjVsLTAuMSwwbC0xMi4zLDcuOUwxNy4yLDMzLjF6Ii8+DQoJPHBhdGggY2xhc3M9InN0MiIgZD0iTTIzLjYsNS4yYzAuNiwwLDEuMiwwLDEuOSwwYy0wLjMsMS4yLTAuNCwyLjUtMC40LDMuN2MwLDkuNiw3LjgsMTcuNSwxNy41LDE3LjVjMC4xLDAsMC4yLDAsMC4zLDANCgkJYy0zLjMsMy4zLTguNiw1LjYtMTQuNyw2LjRsLTAuMiwwTDI3LjgsMzNsLTExLjMsNy4ybDEuMS02LjZsMC4yLTFsLTEtMC4yQzcuNSwzMC43LDEsMjUuMiwxLDE5LjJDMSwxMS41LDExLjEsNS4yLDIzLjYsNS4yDQoJCSBNMjMuNiw0LjJjLTEzLDAtMjMuNiw2LjctMjMuNiwxNWMwLDYuNyw3LDEyLjQsMTYuNywxNC4zbC0xLjUsOC44bDEzLjItOC41YzcuNi0xLDEzLjktNC4zLDE2LjktOC42Yy0wLjksMC4xLTEuOCwwLjItMi43LDAuMg0KCQljLTkuMSwwLTE2LjUtNy40LTE2LjUtMTYuNWMwLTEuNiwwLjItMy4yLDAuNy00LjZDMjUuNyw0LjMsMjQuNyw0LjIsMjMuNiw0LjJMMjMuNiw0LjJ6Ii8+DQo8L2c+DQo8L3N2Zz4NCg==);
}
</style>
